if (__DEV__) {
  require('./components/DocumentationContainer');
  require('./components/DocumentationOverview');
  require('./components/DocumentationCategory');
}

import { getConfig } from 'modules/config';

export default store => ({
  path: '/api-reference',
  getComponent: (nextState, cb) => {
    import(/* webpackChunkName: "documentation" */ './components/DocumentationContainer')
      .then(loadRoute(cb))
      .catch(errorLoading);
  },

  indexRoute: {
    onEnter: (nextState, replace) => replace('/api-reference/overview')
  },

  childRoutes: [
    {
      path: 'overview',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "documentation" */ './components/DocumentationOverview')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: ':category',
      onEnter(nextState, replace) {
        const category = nextState.params.category;
        // allowed category params for /api-reference/:category
        const swaggerConfig = getConfig(store.getState()).swagger;
        const validCategories = Object.keys(swaggerConfig);

        if (!validCategories.includes(category)) {
          return replace('/api-reference/overview');
        }
      },
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "documentation" */ './components/DocumentationCategory')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    }
  ]
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return module => cb(null, module.default);
}



// WEBPACK FOOTER //
// ./src/client/plugins/documentation/index.js